import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { css } from '@emotion/react';
export var DateSharedCssClassName = {
  DATE_WRAPPER: "date-lozenger-container",
  DATE_CONTAINER: 'dateView-content-wrap'
};
export var dateSharedStyle = css(_defineProperty({}, ".".concat(DateSharedCssClassName.DATE_WRAPPER, " span"), {
  whiteSpace: 'unset'
}));